// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Box, TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

type IProps = {
  name: string;
  children: React.ReactNode;
  explainer?: string;
  defaultValue?: string;
};

type Props = IProps & TextFieldProps;

export default function RHFSelect({ explainer, name, children, defaultValue, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <>
            <TextField
              {...field}
              size='small'
              select
              fullWidth
              SelectProps={{ native: true }}
              error={!!error}
              helperText={error?.message}
              value={!field.value ? !defaultValue ? '' : defaultValue : field.value}
              {...other}
            >
              {children}
            </TextField>

            {explainer && field?.value && <Box sx={{ mt: 1, fontSize: 14 }}>{explainer}</Box>}
          </>
        )
      }}
    />
  );
}
